import { TaskFormFields } from 'utils/types/task';

interface CanCreateOrUpdateTaskParams {
  fieldsValues: TaskFormFields;
  hasAssignees: boolean;
  taskAssigneeDateRestriction: boolean;
  isTaskTemplate: boolean;
}

/**
 * Whether Save can be enabled on the v1 Task Add/Update modal, given the
 * current form state.
 *
 * The Start-Date-without-Due-Date branch (CGP-222) matches the v2
 * AddTaskModal in cognota-frontend (useTaskForm.tsx:67-69): a Start Date is
 * only valid alongside a Due Date. The BE accepts a start-only payload today
 * -- both fields are optional on `learnops_task` -- but the UX aligns with the
 * v2 modal so requesters stop hitting downstream error toasts for a state the
 * UI never should have allowed to reach Save.
 */
export const canCreateOrUpdateTask = ({
  fieldsValues,
  hasAssignees,
  taskAssigneeDateRestriction,
  isTaskTemplate,
}: CanCreateOrUpdateTaskParams): boolean => {
  if (fieldsValues.start_date && !fieldsValues.due_date) {
    return false;
  }
  return Boolean(
    ((hasAssignees &&
      taskAssigneeDateRestriction &&
      fieldsValues.start_date &&
      fieldsValues.due_date) ||
      !hasAssignees ||
      (hasAssignees && !taskAssigneeDateRestriction)) &&
      fieldsValues.name &&
      (isTaskTemplate || fieldsValues.project_id)
  );
};
